import { Typography } from "@mui/material";
import { useStyles } from "./styles";

export const SimpleSnackbarText = ({label}) => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.NotificationSnackbarContent}>
                <div className={classes.NotificationIcon}></div>
                <div className={classes.NotificationLabel}>
                    <Typography
                        color={"#271D1C"}
                        lineHeight={"17px"}
                        fontWeight={700}
                        fontFamily={"Inter"}
                        fontSize={"14px"}
                    >
                        {label}
                    </Typography>
                </div>
            </div>
        </>
    );
};
